const styleSheet = () => ({
  hidden: {
    display: 'none',
  },
  container: {
    margin: '9px 0',
  },
  testName: {
    width: '216px',
    color: '#085FE5',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '16px',
    margin: '9px 2px',
  },
  indented: {
    marginLeft: '8px',
  },
});

export default styleSheet;
